exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.j-address-list-right-card-box[data-v-497ab7e8] {\n  height: 100%;\n  min-height: 300px;\n}\n", ""]);

// exports
